<template>
    <div class="vehicle-card card">
        <div class="row">
            <div class="col-7">

                <div class="row">
                    <div class="col-12">
                        <template v-if="derivative">
                            <h3>{{ derivative.manufacturerName }} {{ derivative.rangeName }}</h3>
                            <h4>{{ derivative.modelName }} {{ derivative.derivativeName }}</h4>
                        </template>
                    </div>
                </div>

                <div class="row" v-if="derivative">
                    <div class="col-6">
                        <div class="d-flex flex-column">
                            <span class="key">P11d Value</span>
                            <span class="value">{{ p11DValue }}</span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex flex-column" v-if="derivative?.primaryTechnicalItems?.cO2">
                            <span class="key">{{ derivative.primaryTechnicalItems.primaryTechnicalItems.cO2.technicalItemCaption }}</span>
                            <span class="value">{{ derivative.primaryTechnicalItems.primaryTechnicalItems.cO2.technicalItemValue }}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="d-flex flex-column" v-if="derivative?.primaryTechnicalItems">
                            <span class="key">Fuel Type</span>
                            <span class="value">{{ derivative.primaryTechnicalItems.fuelTypeDescription }}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="d-flex flex-column" v-if="quote && !fuelTypeElectricOrPluginHybrid(derivative.primaryTechnicalItems.fuelTypeDescription)">
                            <span class="key">MPG</span>
                            <span class="value">{{ quote.details.derivedMPG }}g/km</span>
                        </div>
                        <div class="d-flex flex-column" v-if="derivative && fuelTypeElectricOrPluginHybrid(derivative.primaryTechnicalItems.fuelTypeDescription) && derivative.primaryTechnicalItems.primaryTechnicalItems['electricRange(combined)']">
                            <span class="key">Electric Range (combined)</span>
                            <span class="value">{{ derivative.primaryTechnicalItems.primaryTechnicalItems['electricRange(combined)'].technicalItemValue }}</span>
                        </div>
                    </div>
                    <div class="col-6" v-if="derivative && fuelTypeElectricOrPluginHybrid(derivative.primaryTechnicalItems.fuelTypeDescription) && derivative.primaryTechnicalItems.primaryTechnicalItems.enginePowerKW">
                        <div class="d-flex flex-column">
                            <span class="key">Power Output</span>
                            <span class="value">{{ derivative.primaryTechnicalItems.primaryTechnicalItems.enginePowerKW.technicalItemValue }}</span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex flex-column" v-if="hasMpg">
                            <span class="key">Customer Defined MPG</span>
                            <span class="value">{{quote.taxCalculations.mpg}}g/km</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-5">
                <vehicle-image :derivative="derivative" :showMain="true"></vehicle-image>
            </div>

        </div>

        <vehicle-specification :derivative="derivative" :quote="quote"></vehicle-specification>

    </div>

</template>

<script>
import VehicleSpecification from "./vehicle-specification";
import VehicleImage from "./vehicle-image";
import {fuelTypeElectricOrPluginHybrid} from "@/helpers/fuel-type";
import Formatter from "@/helpers/formatter";

export default {
    name: 'vehicle-card',
    components: {VehicleImage, VehicleSpecification, Formatter},
    props: {
        derivative: null,
        quote: null,
        quoteCosts: null,
        type: null,
    },
    data() {
        return {

        }
    },
    methods: {
      fuelTypeElectricOrPluginHybrid
    },
    computed: {
        hasMpg() {
            return this.quote.taxCalculations?.mpg;
        },
        p11DValue() {
            let value = 0;
            if (this.type === 'salsac') {
              value = this.quoteCosts.p11d_value;
            } else {
              value = this?.quote?.details?.pricing?.p11DValue || 0;
            }
            return Formatter.money(value);
        }
    }
};
</script>
